import { render, staticRenderFns } from "./CreateNotifications.vue?vue&type=template&id=f6a855ca&scoped=true&"
import script from "./CreateNotifications.vue?vue&type=script&lang=js&"
export * from "./CreateNotifications.vue?vue&type=script&lang=js&"
import style0 from "./CreateNotifications.vue?vue&type=style&index=0&id=f6a855ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a855ca",
  null
  
)

export default component.exports